<template>
    <!-- <div v-if="showModal" class="modal-overlay" @click.self="closeModal"> -->
    <div v-if="showModal" class="modal-overlay" >
        <div class="modal-content">
            <video ref="demoVideo" controls autoplay webkit-playsinline="true" playsinline="true" :key="refresh">
                <source src="https://branchbook-stor-uat.kbzbank.com/branch_booking_video/demo.mp4"
                    type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <button @click="closeModal" class="skip-button">&#x2715;</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showModal: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            refresh: 0
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        }
    },
    mounted() {
        setTimeout(() => {
            this.refresh += 1;
        }, 200); // Delay to ensure the video is ready to play
    }
}
</script>

<style>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    position: relative;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
}

video {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

.skip-button {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #222;
    color: white;
    border: none;
    height: 32px;
    width: 32px;
    border-radius: 32px;
    cursor: pointer;
}
</style>